import { Injectable } from "@angular/core";
import { DataService } from "../DataService/data.service";
import { Observable } from "rxjs";
import { IOrderDataStatus } from "src/app/Models/Interface/Order/MyOrder/order-data-status";
import { APIName } from "../../Models/APIEndPoints/APIName";
import { HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class OrderStatusService {
  constructor(private dataService: DataService) {}

  getStateForClient(): Observable<IOrderDataStatus[]> {
    let params = new HttpParams();
    // @ts-ignore
    params = params.append("mainCategoryCode", "food");
    return this.dataService.getWithParams(APIName.orderStatus.client, params);
  }

  getStateForSales(): Observable<IOrderDataStatus[]> {
    return this.dataService.get(APIName.orderStatus.sales);
  }

  getStateForLogistics(): Observable<IOrderDataStatus[]> {
    return this.dataService.get(APIName.orderStatus.logistics);
  }
}
